import React from 'react'

import template from './review-1.twig'

import parse from 'html-react-parser'

import {ContentOptions, HeadlineOptions} from '@miro-site/components_utils'

export interface Image {
  src: string
  alt: string
}

export interface Review1Props {
  background: 'blue' | 'pink' | 'yellow'
  image: Image
  headline: HeadlineOptions
  name: ContentOptions
  post: ContentOptions
  logo?: Image
  children?: React.ReactNode
}

import 'lazysizes'
import 'lazysizes/plugins/attrchange/ls.attrchange'

const Review1 = (props: Review1Props): React.ReactElement => {
  return <>{parse(template({...props, ctf_assets: 'images.ctfassets.net'}))}</>
}

export default Review1
